import { useMemo, useState } from "react";
import {
  getHighLow,
  getAreaPatterns,
  generateLotto,
  simulatePrev,
  randInt,
} from "../lib/lotto.js";
import { BallRow } from "./Ball.jsx";

export default function Predictor({ rows, lastDraw }) {
  const [tWeeks, setTWeeks] = useState(45);
  const [count, setCount] = useState(15);
  const [picks, setPicks] = useState([]);

  const { high, low } = useMemo(
    () => getHighLow(rows, tWeeks),
    [rows, tWeeks]
  );
  const areaPatterns = useMemo(() => getAreaPatterns(rows, 16), [rows]);

  const draw = () => {
    if (areaPatterns.length === 0) return;
    const out = [];
    for (let i = 0; i < count; i++) {
      const pat = areaPatterns[randInt(0, areaPatterns.length - 1)][0];
      const highCount = randInt(4, 6);
      const lowCount = 6 - highCount;
      const nums = generateLotto({
        high: highCount,
        low: lowCount,
        highNums: high,
        lowNums: low,
        pattern: pat,
      });
      const sim = simulatePrev(rows, nums);
      out.push({ nums, pattern: pat, sim });
    }
    setPicks(out);
  };

  return (
    <section className="section">
      <h2>예상 번호 — 다음 회차 #{lastDraw + 1}</h2>
      <div className="controls">
        <label>
          최근&nbsp;
          <input
            type="number"
            min={4}
            max={200}
            value={tWeeks}
            onChange={(e) => setTWeeks(Number(e.target.value))}
          />
          &nbsp;회차 기준
        </label>
        <label>
          뽑을 개수&nbsp;
          <input
            type="number"
            min={1}
            max={50}
            value={count}
            onChange={(e) => setCount(Number(e.target.value))}
          />
        </label>
        <button onClick={draw}>예상번호 생성</button>
      </div>
      <p className="muted">
        High {high.length}개 · Low {low.length}개 · 패턴 후보 {areaPatterns.length}
      </p>
      {picks.length > 0 && (
        <div>
          {picks.map((p, i) => (
            <div key={i}>
              <BallRow
                nums={p.nums}
                label={`#${i + 1} ${p.pattern}`}
              />
              <span className="muted" style={{ marginLeft: 88 }}>
                과거 매칭: 5등 {p.sim.counts[3]} · 4등 {p.sim.counts[4]} · 3등{" "}
                {p.sim.counts[5]} · 1등 {p.sim.counts[6]} · 최근 4등 {p.sim.recentFour}회 전
              </span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
